module.exports = __webpack_public_path__ + "7f60047c035b5b8a002378d09eb7533b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/quit-mask2.png
// module id = 1312
// module chunks = 61